import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { fetchPost } from '../../api/common';
import { Profile } from '@par/shared/types/player';
import { ButtonGoogleAuth } from './ButtonGoogleAuth';

type PropTypes = {
  setProfile: (profile: Profile) => void;
};

/** Only mount under `GoogleOAuthProvider` (see `index.js`). */
export const GoogleSignIn = ({ setProfile }: PropTypes) => {
  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (codeResponse: unknown) => {
      const res = await fetchPost(`/authenticate/google-sso`, codeResponse);
      if (res) {
        setProfile(res);
      }
    },
    flow: 'auth-code',
  });

  return (
    <ButtonGoogleAuth text="Google" handleButtonClick={handleGoogleLogin} />
  );
};
